import { useCallback, useContext } from "react";
import { getOrganizationTaskLink } from "@components/organizationView/clients-tasks/organizationTaskLink";
import { ScopeContext } from "@state/scopeContext.lib";

export const taskPath = (taskId: string) => `/?taskId=${taskId}`;

/**
 * A task link for the page the drawer is on: the organization Tasks page on
 * an organization page, else the workspace task. Reads the root scope so a
 * sub-scoped row still links to the organization page.
 */
export function useAgentRunTaskPath(): (
    taskId: string,
    workspaceId: string,
) => string {
    const { organizationId, workspaceId: rootWorkspaceId } =
        useContext(ScopeContext);
    const isOrganizationPage = !!organizationId && !rootWorkspaceId;
    return useCallback(
        (taskId: string, workspaceId: string) =>
            isOrganizationPage
                ? getOrganizationTaskLink({ taskId, workspaceId })
                : taskPath(taskId),
        [isOrganizationPage],
    );
}
